import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { DESC_ENTITY } from '@constants/desc-entity';
import { BondModel, BondRequestModel, PortModel, ValidationMessageModel } from '@data-layer/models/common';
import { CustomState, enumBondRequestState, enumBondType } from '@data-layer/enums/common';
import { CodeRepository } from '@data-layer/repositories';
import { ManagementIsfModel } from '@data-layer/models/management';
import { IsfHelper } from '@helpers/isf.helper';
import { EntityModel } from '@data-layer/models/entities';
import { IsfModel } from '@data-layer/models/isf';
import { take } from 'rxjs/operators';

@Component({
  selector: 'isf-bond-details',
  templateUrl: './isf-bond-details.component.html',
  styleUrls: ['./isf-bond-details.component.scss'],
})
export class IsfBondDetailsComponent implements OnInit, OnChanges {
  @Input() public canEdit: boolean = true;
  @Input() public isShowBR: boolean;
  @Input() public isf: IsfModel | ManagementIsfModel;
  @Output() public entityCodeEdit: EventEmitter<any> = new EventEmitter<any>();

  public info = DESC_ENTITY.BN;
  public bond: BondModel;
  public bondRequest: BondRequestModel;
  public arrivalPort: PortModel;
  public enumBondType: typeof enumBondType = enumBondType;
  public enumBondRequestState: typeof enumBondRequestState = enumBondRequestState;

  constructor(private codeRepository: CodeRepository) {}

  public ngOnInit(): void {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.isf) {
      this.bond = IsfHelper.getBond(this.isf);
      this.bondRequest = IsfHelper.getBondRequest(this.isf);
      this.getPort();
    }
  }

  public get isContinuous(): boolean {
    return this.bond.type === enumBondType.CONTINUOUS;
  }

  public get bondRequestPortCodeValidationText(): string {
    if (!this.bondRequest || !this.bondRequest.portCode) {
      return `BACK_ERROR.MISSING_PORT_CODE`;
    }
    return null;
  }

  public get importerIdentifier(): string {
    return this.importer ? this.importer.entityIdentifier : null;
  }

  public get importerIdentifierQual(): string {
    return this.importer ? 'IDENTIFIER_QUALIFIER.' + this.importer.entityIdentifierQualifier : null;
  }

  public get importer(): EntityModel {
    return this.isf.importer;
  }

  public get bondRequestNotSentError(): string {
    const message: ValidationMessageModel = this.isf.validationMessages ? this.isf.validationMessages['bondRequest'] : null;
    return message ? 'BACK_ERROR.' + message.text : null;
  }

  public getValidationText(field: string): string {
    if (!this.bond || !this.bond.validationMessages || !this.bond.validationMessages[field] || !this.bond.validationMessages[field].text) {
      return null;
    }
    return `BACK_ERROR.${this.bond.validationMessages[field].text}`;
  }

  public gotoEdit(): void {
    this.entityCodeEdit.emit();
  }

  public get singleBondText(): string {
    if (!this.bondRequest?.customState?.header) {
      return this.info.purchaseSingleBondRequested;
    }

    switch (this.bondRequest?.customState?.header) {
      case CustomState.CANCELED:
        return this.info.purchaseSingleBondCanceled;
      case CustomState.CANCELING:
        return this.info.purchaseSingleBondCanceling;
      case CustomState.REFUNDED:
        return this.info.purchaseSingleBondRefunded;
      default:
        return this.info.purchaseSingleBondRequested;
    }
  }

  private getPort(): void {
    if (this.bondRequest && this.bondRequest.portCode) {
      this.codeRepository
        .getDomesticPort(this.bondRequest.portCode)
        .pipe(take(1))
        .subscribe((port: PortModel) => {
          this.arrivalPort = port;
        });
    }
  }
}
